import i18n from "../i18n";
import {
    ACTIVATED_STATUS,
    ALL_CATEGORY,
    ALL_ROLES,
    ALL_SATISFACTION,
    ALL_STATUS,
    ATTENDANCE,
    COURSE_STATUS,
    DRAFT_NOT_EMBEDDED_TEXT,
    DRAFT_TEXT,
    FEEDBACK_CATEGORY,
    GRADED_POLL,
    MERGED_MODE,
    NO_LINKAGE,
    READY_TO_SHARE,
    ROLES,
    SCHEDULED,
    SHARED_BY_QUESTION,
    SHARED_ENTIRELY,
    SURVEY,
    UNFINISHED,
} from "./constants";

// Status / type / role values stay English because they are compared in filters and logic;
// translate them only where they are rendered.
const labelKeyByValue = {
    [DRAFT_TEXT]: "poll.draftStatus",
    [UNFINISHED]: "poll.statusUnfinishedDraft",
    [DRAFT_NOT_EMBEDDED_TEXT]: "poll.draftEmbedLabel",
    [READY_TO_SHARE]: "poll.statusReadyToRelease",
    [SHARED_BY_QUESTION]: "poll.statusReleasedByQuestion",
    [SHARED_ENTIRELY]: "poll.statusReleasedEntireActivity",
    [SCHEDULED]: "poll.statusScheduledRelease",
    [MERGED_MODE]: "poll.mergedModeText",
    [GRADED_POLL]: "poll.gradedPollLabel",
    [SURVEY]: "poll.surveyLabel",
    [ATTENDANCE]: "attendance.label",
    [NO_LINKAGE]: "user.noLinkageText",
    [ACTIVATED_STATUS]: "poll.activatedStatus",
    [COURSE_STATUS]: "course.label",
    [ALL_STATUS]: "poll.allStatus",
    [ALL_CATEGORY]: "poll.allCategories",
    [ALL_ROLES]: "user.allRolesText",
    [ALL_SATISFACTION]: "poll.allSatisfaction",
    [FEEDBACK_CATEGORY.Suggestion]: "poll.feedbackCategorySuggestion",
    [FEEDBACK_CATEGORY.Comment]: "poll.feedbackCategoryComment",
    [FEEDBACK_CATEGORY.Other]: "poll.feedbackCategoryOther",
};
for (const role of Object.values(ROLES)) {
    labelKeyByValue[role.display] = role.labelKey;
}

export const translateDisplayValue = (value) =>
    typeof value === "string" && labelKeyByValue[value] ? i18n.t(labelKeyByValue[value]) : value;
